/* Slide-out cart behaviour. Config comes from the #xcData JSON block. */
(function(){
  var el=document.getElementById('xcPanel');
  if(!el||el.dataset.init==='1')return; el.dataset.init='1';
  var ov=document.getElementById('xcOverlay'),body=document.getElementById('xcBody'),
      foot=document.getElementById('xcFoot'),subEl=document.getElementById('xcSub'),
      cntEl=document.getElementById('xcCount');
  var CFG={locale:'en',isFr:false,cartUrl:'/cart',shopUrl:'/collections/all',upsells:[]};
  try{ CFG=JSON.parse(document.getElementById('xcData').textContent); }catch(e){}

  var T = CFG.isFr ? {
    empty:'Votre panier est vide.', browse:'Découvrir la boutique',
    items:function(n){return n+(n>1?' articles':' article');},
    remove:'Retirer', free:'Offert', add:'Ajouter',
    ups:'Souvent ajouté à la commande'
  } : {
    empty:'Your cart is empty.', browse:'Browse the shop',
    items:function(n){return n+(n>1?' items':' item');},
    remove:'Remove', free:'Free', add:'Add',
    ups:'Often added to the order'
  };

  function fmt(cents,cur){
    try{ return new Intl.NumberFormat(CFG.locale,{style:'currency',currency:cur||'EUR'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2)+' '+(cur||'EUR'); }
  }
  // cart.js returns HTML-escaped strings; decode before re-escaping or we double-encode.
  var _t=document.createElement('textarea');
  function dec(s){ _t.innerHTML=String(s==null?'':s); return _t.value; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function safe(s){ return esc(dec(s)); }

  var busy=false;
  function open(){ ov.dataset.open='true'; el.dataset.open='true';
    ov.setAttribute('aria-hidden','false'); el.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    var c=document.getElementById('xcClose'); if(c)c.focus();
  }
  function close(){ ov.dataset.open='false'; el.dataset.open='false';
    ov.setAttribute('aria-hidden','true'); el.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
  }

  function inCart(cart,vid){
    for(var i=0;i<cart.items.length;i++){ if(cart.items[i].variant_id===vid) return true; }
    return false;
  }

  function render(cart){
    if(!cart||typeof cart.item_count!=='number')return;   // guard against non-cart payloads
    cntEl.textContent = cart.item_count ? T.items(cart.item_count) : '';
    if(!cart.item_count){
      body.innerHTML='<div class="xc__empty">'+T.empty+'<br><a href="'+esc(CFG.shopUrl)+'">'+T.browse+'</a></div>';
      foot.hidden=true; return;
    }
    var h='';
    cart.items.forEach(function(it,idx){
      var props='';
      if(it.properties){
        Object.keys(it.properties).forEach(function(k){
          if(k.charAt(0)==='_')return;
          var val=it.properties[k]; if(!val)return;
          props+='<div class="xc__props">'+safe(k)+' : '+safe(val)+'</div>';
        });
      }
      var isFree=it.line_price===0;
      h+='<div class="xc__row">'+
        '<div class="xc__ph">'+(it.image?'<img src="'+esc(it.image)+'" alt="" width="124" height="124" loading="lazy">':'')+'</div>'+
        '<div class="xc__mid"><span class="xc__nm">'+safe(it.product_title)+'</span>'+
          (it.variant_title&&it.variant_title!=='Default Title'?'<span class="xc__var">'+safe(it.variant_title)+'</span>':'')+
          props+
          (isFree?'':'<span class="xc__qty"><button type="button" data-line="'+(idx+1)+'" data-to="'+(it.quantity-1)+'" aria-label="-">−</button><span>'+it.quantity+'</span><button type="button" data-line="'+(idx+1)+'" data-to="'+(it.quantity+1)+'" aria-label="+">+</button></span>')+
        '</div>'+
        '<div class="xc__rt">'+
          (isFree?'<span class="xc__free">'+T.free+'</span>':'<span class="xc__pr">'+fmt(it.line_price,cart.currency)+'</span>')+
          '<button type="button" class="xc__rm" data-line="'+(idx+1)+'" data-to="0">'+T.remove+'</button>'+
        '</div></div>';
    });

    var avail=CFG.upsells.filter(function(u){ return !inCart(cart,u.id); });
    if(avail.length){
      h+='<div class="xc__ups"><p class="xc__upsh">'+T.ups+'</p>';
      avail.slice(0,3).forEach(function(u){
        h+='<div class="xc__up">'+
          '<div class="xc__uph">'+(u.img?'<img src="'+esc(u.img)+'" alt="" width="84" height="84" loading="lazy">':'🛡️')+'</div>'+
          '<div class="xc__upm"><span class="xc__upn">'+safe(u.title)+'</span>'+
            (u.blurb?'<span class="xc__upd">'+safe(u.blurb)+'</span>':'')+'</div>'+
          '<div class="xc__upb"><span class="xc__upp">'+fmt(u.price,cart.currency)+'</span>'+
            '<button type="button" class="xc__add" data-add="'+u.id+'" aria-label="'+T.add+'">+</button></div>'+
        '</div>';
      });
      h+='</div>';
    }

    body.innerHTML=h;
    subEl.textContent=fmt(cart.total_price,cart.currency);
    foot.hidden=false;
  }

  function load(){
    return fetch(CFG.cartUrl+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(c){ render(c); return c; });
  }

  // /cart/add.js returns only the added lines, not a cart object, so always reload.
  function mutate(url,payload){
    if(busy)return Promise.resolve();
    busy=true; el.setAttribute('aria-busy','true');
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){ if(!r.ok)throw new Error(r.status); return r.json(); })
      .then(function(){ return load(); })
      ['catch'](function(){ window.location.href=CFG.cartUrl; })
      ['finally'](function(){ busy=false; el.removeAttribute('aria-busy'); });
  }

  body.addEventListener('click',function(e){
    var q=e.target.closest('[data-line]');
    if(q){ mutate(CFG.cartUrl+'/change.js',{line:Number(q.getAttribute('data-line')),quantity:Number(q.getAttribute('data-to'))}); return; }
    var a=e.target.closest('[data-add]');
    if(a){ a.disabled=true; mutate(CFG.cartUrl+'/add.js',{items:[{id:Number(a.getAttribute('data-add')),quantity:1}]}); return; }
  });

  document.getElementById('xcClose').addEventListener('click',close);
  document.getElementById('xcCont').addEventListener('click',close);
  ov.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&el.dataset.open==='true')close(); });

  // Cart icon / cart links open the drawer instead of navigating.
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]');
    if(!a)return;
    var href=a.getAttribute('href')||'';
    if(/\/cart(\?|$)/.test(href)&&!/\/cart\/(add|change|update|clear)/.test(href)){
      e.preventDefault(); load().then(open);
    }
  },true);

  // Any product form adds via AJAX and opens the drawer, with a native fallback.
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||f.tagName!=='FORM')return;
    var action=f.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1)return;
    if(f.dataset.xb==='1'||f.dataset.xba==='1')return;   // handled by the bundle engine
    e.preventDefault();
    // On the theme's own product template, Horizon's product-form.js also posts
    // this submit, which added the item twice. We run first (document capture),
    // so stop the event here and stay the single owner of the add.
    e.stopImmediatePropagation();
    var btn=f.querySelector('[name="add"]');
    if(btn)btn.disabled=true;
    var fd=new FormData(f);
    var item={id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1),properties:{}};
    fd.forEach(function(v,k){ var m=k.match(/^properties\[(.+)\]$/); if(m&&v)item.properties[m[1]]=v; });
    fetch(CFG.cartUrl+'/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){ if(!r.ok)throw new Error(r.status); return r.json(); })
      .then(function(){ if(btn)btn.disabled=false; return load(); })
      .then(open)
      ['catch'](function(){ if(btn)btn.disabled=false; HTMLFormElement.prototype.submit.call(f); });
  },true);

  document.addEventListener('x:cart:open',function(){ load().then(open); });
  window.xCartOpen=function(){ load().then(open); };
})();
